import { inject, Injectable, signal } from '@angular/core';
import { UserService } from './user.service';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private storage = inject(StorageService);
  private userService = inject(UserService);
  private readonly TOKEN_KEY = 'auth-token';
  public isLoggedIn = signal<boolean>(this.hasToken());

  setSession(response: any) {
    this.storage.setItem(this.TOKEN_KEY, response.data.accessToken);
    this.userService.setUser(this.userService.normalizaUser(response.data.user));
    this.storage.setItem('sidebarCollapsed', 'false');
    this.isLoggedIn.set(true);
  }

  handleLoginError() {
    this.isLoggedIn.set(false);
  }

  clearSession() {
    this.clearToken();
    this.storage.clear();
    this.userService.clearUser();
  }

  getToken(): string | null {
    return this.storage.getItem(this.TOKEN_KEY);
  }

  clearToken(): void {
    this.storage.removeItem(this.TOKEN_KEY);
    this.isLoggedIn.set(false);
  }

  hasToken(): boolean {
    return !!this.storage.getItem(this.TOKEN_KEY);
  }
}
